import { cn } from "@/lib/utils";
import { BREAKPOINTS } from "@/settings";
import React from "react";
import { useMediaQuery } from "usehooks-ts";

interface SidePanelProps {
  children: React.ReactNode;
  isOnSolutionsPage?: boolean;
}

const SbcSidePanel: React.FC<SidePanelProps> = ({
  children,
  isOnSolutionsPage,
}) => {
  const isMobile = useMediaQuery(BREAKPOINTS.MOBILE.query);
  return (
    <article
      className={cn(
        "bg-panel-background rounded-lg flex flex-col gap-y-[1px]",
        isMobile ? "w-full rounded-none" : "w-[340px]",
        isOnSolutionsPage && "rounded-none",
        isOnSolutionsPage && isMobile && "mb-12",
      )}
    >
      {children}
    </article>
  );
};

export default SbcSidePanel;
